module.exports = __webpack_public_path__ + "static/media/twitter.24d4a8d2.svg";